import { z } from "zod";
import { EventIdPublicSchema } from "@shared/schemas/branded-id.schemas";
import type { DirectoryTabType } from "./tab.types";
import type { ConnectionRequestSummary } from "@shared/schemas/connection-request.schemas";
import type { DirectoryCard } from "@frontend/shared/domain/types/directory-card.types";
import type {
  ConnectionRequestIdPublic,
  EventIdPublic,
  EventParticipantIdPublic,
} from "@shared/schemas/branded-id.schemas";
import type { IntroOriginDataType } from "@shared/schemas/intro-origin.schemas";

export const GetEntriesOptionsSchema = z.object({
  eventIdPublic: EventIdPublicSchema,
  tab: z.custom<DirectoryTabType>().optional(),
  searchQuery: z.string().optional(),
  enabled: z.boolean().optional(),
  limit: z.number().optional(),
});
export type GetEntriesOptions = z.infer<typeof GetEntriesOptionsSchema>;

export type ConnectionRequestDirectionType = "sent" | "received";

export interface GetConnectionRequestsOptions {
  readonly eventIdPublic: EventIdPublic;

  readonly direction?: ConnectionRequestDirectionType;
  readonly enabled?: boolean;
}

export interface GetConnectedProfilesOptions {
  readonly eventIdPublic: EventIdPublic;
  readonly enabled?: boolean;
}

export interface GetProfileDetailOptions {
  readonly eventIdPublic: EventIdPublic;
  readonly participantIdPublic: EventParticipantIdPublic;
  readonly enabled?: boolean;
}

export interface GetSuggestionsOptions {
  readonly eventIdPublic: EventIdPublic;
  readonly participantIdPublic: EventParticipantIdPublic;
  readonly enabled?: boolean;
}

export interface GetContactInfoOptions {
  readonly eventIdPublic: EventIdPublic;
  readonly requestIdPublic: ConnectionRequestIdPublic;
  readonly enabled?: boolean;
}

export type RespondToRequestActionType = "accept" | "decline";

export interface RequestIntroVariables {
  readonly eventIdPublic: EventIdPublic;
  readonly targetParticipantIdPublic: EventParticipantIdPublic;
  readonly message?: string;
  readonly origin: string;
  readonly originData: IntroOriginDataType | null;
}

export interface RespondToRequestVariables {
  readonly eventIdPublic: EventIdPublic;
  readonly requestIdPublic: string;
  readonly action: RespondToRequestActionType;
}

export interface MarkIntroSeenVariables {
  readonly requestIdPublic: string;
  readonly eventIdPublic: EventIdPublic;
}

export interface RespondToRequestContext {
  readonly previousRequests?: readonly ConnectionRequestSummary[] | undefined;
  readonly previousConnected?: readonly DirectoryCard[] | undefined;
}
